export const QUERY_GENERATE = "QUERY_GENERATE";
export const QUERY_PATH = "QUERY_PATH";

export const RESPONSE_PROGRESS = "RESPONSE_PROGRESS";
export const RESPONSE_PATH = "RESPONSE_PATH";
export const RESPONSE_SEGMENT = "RESPONSE_SEGMENT";
export const RESPONSE_MAP = "RESPONSE_MAP";
export const RESPONSE_ERROR = "RESPONSE_ERROR";
